import { createMuiTheme } from "@material-ui/core/styles";

let theme = createMuiTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1450,
    },
  },
  palette: {
    primary: {
      light: "#ecf2f7",
      main: "#E38544",
      dark: "#006db3",
    },
    secondary: {
      main: "#F0F3F4",
    },
    white: {
      main: "#FFFFFF",
    },
    grey: {
      main: "#F0F3F4",
    },
  },
  typography: {
    fontFamily: ["Arial"],
    h5: {
      fontWeight: 500,
      fontSize: 26,
      letterSpacing: 0.5,
    },
  },
  shape: {
    borderRadius: 8,
  },
  props: {
    MuiTab: {
      disableRipple: true,
    },
  },
  mixins: {
    toolbar: {
      minHeight: 48,
    },
  },
});

theme = {
  ...theme,
  overrides: {
    MuiCssBaseline: {
      "@global": {
        html: {
          font: "normal normal normal 14px/16px Arial",
          width: "100%",
        },
        body: {
          margin: 0,
          width: "100%",
          fontSize: "1rem",
        },
        ".leaflet-container": {
          height: "100%",
        },
        ".legend": {
          lineHeight: "18px",
          color: "#555",
        },
        ".legend i": {
          width: "18px",
          height: "18px",
          float: "left",
          marginRight: "8px",
          opacity: 0.7,
        },
        ".info": {
          padding: " 6px 8px",
          font: " 14px/16px Arial, Helvetica, sans-serif",
          background: " white",
          background: " rgba(255,255,255,0.8)",
          boxShadow: " 0 0 15px rgba(0,0,0,0.2)",
          borderRadius: " 5px",
          lineHeight: "18px",
          textAlign: "left",
        },
        ".leaflet-container a.leaflet-popup-close-button": {
          fontSize: "18px!important",
        },
        ".tab-title": {
          fontSize: "1.5rem",
          fontWeight: "bold",
          color: "#152555",
          textAlign: "left",
          marginLeft: "8px",
          marginBottom: "24px",
        },
        ".case-study-list": {
          listStyleType: "none",
        },
        ".case-study-item": {
          height: "30px",
          lineHeight: "30px",
          textAlign: "left",
          fontSize: "1rem",
          cursor: "pointer",
        },
        ".case-study-item:hover": {
          color: "rgb(35, 74, 126)",
          textDecoration: "underline",
        },
        ".MuiTab-textColorSecondary.Mui-selected": {
          backgroundColor: "#29B5A4",
          color: "#fff",
        },
        ".MuiButtonBase-root.MuiTab-textColorPrimary.Mui-selected": {
          color: "#fff",
          backgroundColor: "#4C92D3",
        },
        ".MuiTab-textColorSecondary.Mui-selected:hover": {
          backgroundColor: "#29B5A4",
          color: "#fff",
        },
        ".MuiButtonBase-root.MuiTab-textColorPrimary.Mui-selected:hover": {
          color: "#fff",
          backgroundColor: "#4C92D3",
        },
      },
    },
    MuiDrawer: {
      paper: {
        backgroundColor: "#18202c",
      },
    },
    MuiButton: {
      label: {
        textTransform: "none",
      },
      contained: {
        boxShadow: "none",
        "&:active": {
          boxShadow: "none",
        },
      },
    },
    MuiTabs: {
      root: {
        marginLeft: theme.spacing(1),
      },
      indicator: {
        height: 3,
        borderTopLeftRadius: 3,
        borderTopRightRadius: 3,
        backgroundColor: theme.palette.common.white,
      },
    },
    MuiTab: {
      root: {
        textTransform: "none",
        margin: "0 16px",
        minWidth: 0,
        padding: 0,
        [theme.breakpoints.up("md")]: {
          padding: 0,
          minWidth: 0,
        },
      },
    },
    MuiIconButton: {
      root: {
        padding: theme.spacing(1),
      },
    },
    MuiTooltip: {
      tooltip: {
        borderRadius: 4,
      },
    },
    MuiDivider: {
      root: {
        backgroundColor: "#404854",
      },
    },
    MuiListItemText: {
      primary: {
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
    MuiListItemIcon: {
      root: {
        color: "inherit",
        marginRight: 0,
        "& svg": {
          fontSize: 20,
        },
      },
    },
    MuiAvatar: {
      root: {
        width: 32,
        height: 32,
      },
    },
  },
};

export default theme;
